
import { watcherService } from "@/services/watcherService";
import { computed, defineComponent, ref } from "vue";
import Draggable from "vuedraggable";
import SitemapRow from "./SitemapRow.vue";

export default defineComponent({
	components: { SitemapRow, Draggable },
	setup() {
		const {
			sitemaps,
			sitemapStats,
			validateSitemap,
			addSitemap,
			reorderSitemaps,
			seenStatuses,
			continueWatching,
			pauseWatching,
			maxRequests,
			setMaxRequests,
			delayMS,
			setDelay,
			randomize,
			setRandomize,
		} = watcherService;

		const newSitemapInput = ref<null | HTMLInputElement>(null);
		const newSitemap = ref("");
		const handleAddSitemap = async () => {
			if (!validateSitemap(newSitemap.value)) {
				newSitemapInput.value?.classList.add("is-invalid");
				return;
			}

			newSitemapInput.value?.classList.remove("is-invalid");
			try {
				await addSitemap(newSitemap.value);
				newSitemap.value = "";
			} catch (e) {
				console.error(e);
				newSitemapInput.value?.classList.add("is-invalid");
			}
		};

		const startAll = () => {
			for (let sitemap of sitemaps.value) {
				continueWatching(sitemap);
			}
		};

		const pauseAll = () => {
			for (let sitemap of sitemaps.value) {
				pauseWatching(sitemap);
			}
		};

		const toggleRandomize = () => {
			setRandomize(!randomize.value);
		};

		// vuedraggable requires an array of objects to operate so we convert
		// sitemap urls to objects with one property
		const sitemapsWrapped = computed(() =>
			sitemaps.value.map(sitemap => ({
				sitemap,
			}))
		);
		const handleDragEnd = (event: any) => {
			const newSitemapsOrder = sitemaps.value.slice();
			const item = newSitemapsOrder.splice(event.oldIndex, 1);
			newSitemapsOrder.splice(event.newIndex, 0, ...item);
			reorderSitemaps(newSitemapsOrder);
		};

		return {
			sitemaps,
			sitemapStats,

			addSitemap,
			newSitemap,
			handleAddSitemap,
			newSitemapInput,

			seenStatuses,

			startAll,
			pauseAll,

			maxRequests,
			setMaxRequests,

			delayMS,
			setDelay,

			randomize,
			toggleRandomize,

			sitemapsWrapped,
			handleDragEnd,
		};
	},
});
